module.exports = __webpack_public_path__ + "media/images/category/feature/poj/og-poj-25a553a155a9dba93f33719f66a9a065.png";